import { render } from "./ViewsSurveysView.vue?vue&type=template&id=7a2b3086"
import script from "./ViewsSurveysView.vue?vue&type=script&lang=js"
export * from "./ViewsSurveysView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__